<form [formGroup]="contactInformationForm">
    <kendo-formfield class="textbox">
        <kendo-label class="form-label" [for]="email" text="{{'contactinformation.emailAddress' | translate}} {{required ? '*' : ''}}" [infotooltip]="'kontakt.emailadresse'"></kendo-label>
        <kendo-textbox #email
        formControlName="emailAddress"
        showSuccessIcon="initial"
        showErrorIcon="initial"
        [appinfotext]="'kontakt.emailadresse'"
        preventEmptyFormatter
        [maxlength]=100
         ></kendo-textbox>
        <kendo-formerror *ngIf="emailErrorMessage">{{emailErrorMessage}}</kendo-formerror>
    </kendo-formfield>
    <kendo-formfield class="textbox">
        <kendo-label class="form-label" [for]="telephone" text="{{(kontaktIsAntragsteller ? 'contactinformation.mobileNumber' : 'contactinformation.telephoneNumber') | translate}} {{required ? '*' : ''}}" [infotooltip]="'kontakt.telefonnummer'"></kendo-label>
        <kendo-textbox #telephone
        formControlName="telephoneNumber"
        showSuccessIcon="initial"
        showErrorIcon="initial"
        [appinfotext]="'kontakt.telefonnummer'"
        preventEmptyFormatter
        [maxlength]=100
        ></kendo-textbox>
        <kendo-formerror *ngIf="telephoneNumberErrorMessage">{{telephoneNumberErrorMessage}}</kendo-formerror>
    </kendo-formfield>
    <kendo-formfield class="textbox" *ngIf="!kontaktIsAntragsteller">
        <kendo-label class="form-label" [for]="jobtitle" text="{{'contactinformation.position' | translate}}" [infotooltip]="'kontakt.position'"></kendo-label>
        <kendo-textbox #jobtitle
        formControlName="jobtitle"
        showSuccessIcon="initial"
        showErrorIcon="initial"
        [appinfotext]="'kontakt.position'"
        preventEmptyFormatter
        [maxlength]=100
        ></kendo-textbox>
    </kendo-formfield>
</form>
